"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupMenuStyled = exports.ItemDivider = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../../style/colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SIZE_TO_WIDTH = {
  md: '200px',
  lg: '208px'
};
const PopupMenuStyled = exports.PopupMenuStyled = /*#__PURE__*/_styledComponents.default.ul.withConfig({
  displayName: "style__PopupMenuStyled",
  componentId: "bufferapp-ui__sc-fm9jo8-0"
})(["position:absolute;z-index:1000;border:1px solid ", ";box-sizing:border-box;box-shadow:", ";border-radius:4px;max-height:calc( 100vh - 64px );scroll:auto;display:", ";min-width:", ";max-width:", ";width:", ";background-color:", ";top:100%;bottom:initial;margin-bottom:0;margin-top:8px;padding:8px 0;transform:translateX( ", " );right:", ";left:", ";&[role='menu'] > li{& button:focus{outline:1px solid ", ";}}&:focus{outline:none;}"], _colors.gray, _colors.grayShadow, props => props.isOpen ? 'initial' : 'none', props => SIZE_TO_WIDTH[props.size], props => SIZE_TO_WIDTH[props.size], props => SIZE_TO_WIDTH[props.size], _colors.white, props => props.horizontalOffset ? props.horizontalOffset : '0', props => {
  const {
    xPosition
  } = props;
  if (xPosition === 'right') return 0;
  return '';
}, props => {
  const {
    xPosition
  } = props;
  if (xPosition === 'left') return 0;
  return '';
}, _colors.blue);
const ItemDivider = exports.ItemDivider = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "style__ItemDivider",
  componentId: "bufferapp-ui__sc-fm9jo8-1"
})(["background-color:", ";height:1px;margin-bottom:8px;margin-top:8px;padding:0;pointer-events:none;width:100%;list-style:none;margin-top:", ";"], _colors.grayLighter, props => props.type && props.type === 'header' ? '15px' : '');